// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1_7K9","detailsBorder":"styles_detailsBorder__1rxTK"};